import { render } from "./Solution.vue?vue&type=template&id=12db0176&scoped=true&ts=true"
import script from "./Solution.vue?vue&type=script&lang=ts"
export * from "./Solution.vue?vue&type=script&lang=ts"

import "./Solution.vue?vue&type=style&index=0&id=12db0176&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12db0176"]])

export default __exports__